// extracted by mini-css-extract-plugin
export default {"sectionContainer1":"Contact_sectionContainer1__ejP4Y","secondaryTitleContact":"Contact_secondaryTitleContact__+L78E","info":"Contact_info__6YhDx"};